import { getProductScope } from '@discover-frontend/utils';

import { API } from 'src/constants/config';
import { ApiRequestHeader, fetchWrapper } from '../../../../utils';
import { isEmpty } from '../../../../utils/misc';

const getEndpointBaseUrl = (api, mock) =>
  mock ? API[api].MOCK_BASE_URL : API[api].BASE_URL;

const engineUrl = getEndpointBaseUrl('ENGINE', false);
const workspaceUrl = getEndpointBaseUrl('WORKSPACE', false);

const buildQueryParams = (q, sources, additionalParams = []) => {
  const queryStringArr = [];

  if (!isEmpty(q)) {
    const encoded = encodeURIComponent(q.replace("'", ''));
    queryStringArr.push(`q=${encoded}`);
  }

  queryStringArr.push(`scope=${getProductScope()}`);
  if (sources) queryStringArr.push(`sources=${sources}`);

  return queryStringArr.concat(additionalParams).join('&');
};

export const fetchSearchResults = (q, sources) => {
  if (sources === 'saved-queries') {
    return Promise.resolve({ response: { data: [] } });
  }

  const additionalParams = [
    'limit=50',
    'variable_types=item,category,psychographic,demographic',
  ];

  const queryParams = buildQueryParams(q, sources, additionalParams);
  const endpointUrl = `${engineUrl}/variables/search?${queryParams}`;
  const authRequestHeader = ApiRequestHeader();

  return fetchWrapper(endpointUrl, authRequestHeader);
};

export const fetchSavedQueries = (q, dataSource) => {
  const additionalParams = [
    'type=audience',
    'access=private',
    'persistence=permanent',
    'flat=true',
    'audience_types=interest,conversation',
    'limit=50',
    `data_source=${dataSource}`,
  ];

  const queryParams = buildQueryParams(q, undefined, additionalParams);
  const endpointUrl = `${workspaceUrl}/repository?${queryParams}`;
  const authRequestHeader = ApiRequestHeader();

  return fetchWrapper(endpointUrl, authRequestHeader);
};
